import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogsComponent } from './logs.component';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule, ButtonModule, CalendarModule, PanelModule, ProgressSpinnerModule, TableModule } from 'primeng';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [LogsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    InputTextModule,
    CalendarModule,
    TableModule,
    PanelModule,
    ButtonModule,
    BlockUIModule,
    ProgressSpinnerModule
  ]
})
export class LogsModule { }
